export enum ORDER_STATUS {
	Created = 0,
	Canceled = 1,
	Filled = 2,
	Validated = 3,
	CancellationRequest = 4,
}
